import { createSlice } from "@reduxjs/toolkit";

const initialNotesState = {
    filterResult: null,
}


const notesSlice = createSlice({
    name: 'notes',
    initialState: initialNotesState,
    reducers: {
        setFilterResult(state, data) {
            state.filterResult = data.payload
        },
    }
})

export const notesActions = notesSlice.actions

export default notesSlice.reducer